import { handleAxiosError } from '@/shared/utils';
import { useUiStore } from '@/store/ui';
import React, { useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
//import { read, utils } from 'xlsx';
import {
  deleteFileNewAwt,
  GetNodoParams,
  useCreateFileAwt,
  useCreateInventariableUploadExcel,
  useCreateProveedorUploadExcel,
  useFetchImportarExcelNodo,

  useFetchImportarExcelRadioBase,
  useFetchImportarExcelSector,
  useFetchOLTsImport,
  useFetchOLTsTroncalesImport,
} from '../actions/erp';
import { AlertSeverityEnum, ApiFileRespAWT, Nodo, OLTBase, OLTsTroncalBase, ProveedorExcel, RadioBase, Sector, SectorParams } from '../interfaces';
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
import { BucketAwtENUM } from '../constants';
import { toast } from 'react-toastify';
import { useAuthStore } from '@/store/auth';


//customs interfaces
interface IRadioBaseExcel {
  codigo: string;
  nombre: string;
  direccion: string;
  coordenadas: string;
  estado: string;
}
interface IOLTExcel {
  PROVINCIAS: string;
  NOMBRE_OLT: string;
  HOSTNAME: string;
  PPPoE: string;
  IP_PPPoE: string;
  RED_IPv4: string;
  RED_IPv6: string;
};


function newName(nameFile: string) {
  return encodeURIComponent(nameFile)
}


export const useUploadFile = () => {

  const setConfirmDialog = useUiStore.getState().setConfirmDialog;
  const setConfirmDialogIsOpen = useUiStore.getState().setConfirmDialogIsOpen;

  const fetchImportarExcelNodo = useFetchImportarExcelNodo({});
  //  const fetchImportarExcelProveedor = usefetchImportarExcelProveedor({})
  const fetchImportarExcelRadioBase = useFetchImportarExcelRadioBase();
  const fetchImportarExcelSector = useFetchImportarExcelSector({});
  const fetchImportarExcelOLTs = useFetchOLTsImport();
  const fetchImportarExcelOLTsTroncales = useFetchOLTsTroncalesImport()
  const { mutateAsync: fetchImportarExcelProveedor,
    isPending: isPendingProveedorExcel
  } = useCreateProveedorUploadExcel()

  const { mutateAsync: fetchImportarExcelInventario,
    isPending: isPendingInventableExcel } = useCreateInventariableUploadExcel();
  const setAlert = useUiStore.getState().setAlert;

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [cleanUploadFile, setCleanUploadFile] = useState<any[]>([]); ///* array a 

  const { mutateAsync: mutateAsyncCreateFileDocumentNew } = useCreateFileAwt();

  const handleUploadFile = async (
    archivo: File | null,
    path: string,
  ): Promise<ApiFileRespAWT> => {
    try {
      if (!archivo) return { id_archivos: '', url: '' };
      const arrayBuffer = await archivo.arrayBuffer();
      const nuevoArchivo = new File(
        [arrayBuffer],
        newName(archivo.name),
        { type: archivo.type }
      );
      // const nuevoArchivo = new File([archivo], newName(archivo.name), { type: archivo.type });
      const extensionName = nuevoArchivo.name.split('.');

      const newUid = uuidv4();
      const keyFile = `${newUid}.${extensionName[extensionName.length - 1]}`;
      const resp = await mutateAsyncCreateFileDocumentNew({
        selectedFile: nuevoArchivo,
        key: keyFile,
        path: path
      });

      return resp.data!;
    } catch (error) {
      handleAxiosError(error, 'Error al subir el/los archivo(s). Por favor, verifique su conexión a internet e intente nuevamente.');
      throw new Error('Error: ' + error);
    }
  };

  const handleUpdateFile = async (
    archivo: File,
    path: string,
    url: string,
    pathAuto: boolean = false
  ): Promise<string | null> => {
    try {
      if (!archivo) return null;

      const arrayBuffer = await archivo.arrayBuffer();
      const nuevoArchivo = new File([arrayBuffer], newName(archivo.name), { type: archivo.type });

      const aux = url.split('/');
      if (pathAuto) path = `${aux[aux.length - 3]}/${aux[aux.length - 2]}`;

      const resp = await mutateAsyncCreateFileDocumentNew({
        selectedFile: nuevoArchivo,
        key: aux[aux.length - 1],
        path: path,
      });

      return resp.data!.url!;
    } catch (error) {
      handleAxiosError(error, 'Error al subir el/los archivo(s). Por favor, verifique su conexión a internet e intente nuevamente.');
      throw Error('Error: ' + error);
    }
  };

  const handleDeleteFile = async (path: string, url?: string) => {

    try {

      if (!url) return;

      const aux = url.split('/');
      await deleteFileNewAwt({ key: aux[aux.length - 1], path: path });
    } catch (error) {
      throw Error(`Error: ${error}`)
    }

  }


  const handleImportarExcelSectorCobertura = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const file = event.target.files[0];
      setUploadFile(file);

      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const data = e.target?.result;
          if (data) {

            const wb = XLSX.read(data, { type: 'binary' });
            const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
            const aux: Sector[] = XLSX.utils.sheet_to_json<Sector>(ws, { header: ['nombre', 'provincia', 'ciudad', 'zona'] });
            const auxClean: SectorParams[] = [];
            aux.shift();
            aux.map((value) => {
              auxClean.push({
                sector: value.nombre.toLocaleUpperCase(),
                provincia: value.provincia,
                ciudad: value.ciudad,
                zona: value.zona,
                cobertura: true,
              })
            });

            if (aux.length == 0) setAlert(true, 'No se han encontrado datos en el excel.', AlertSeverityEnum.warning);

            if (aux.length > 0) {
              setConfirmDialogIsOpen(true);
              setConfirmDialog({
                cancelTextBtn: 'Cancelar',
                isOpen: true,
                title: '¡Confirmación!',
                subtitle: `El archivo Excel "${file.name}" se ha cargado correctamente. ¿Te gustaría importar a la base de datos?`,
                onClose() {
                  setUploadFile(null);
                  setConfirmDialogIsOpen(false);
                },
                async onConfirm() {
                  if (!file) return setAlert(true, 'Archivo no cargado', AlertSeverityEnum.warning);
                  await fetchImportarExcelSector.mutateAsync({
                    sectores: auxClean
                  });

                  setConfirmDialogIsOpen(false);
                },
              });
            }

            setCleanUploadFile(auxClean);
          }
        };
        reader.readAsArrayBuffer(file);
      } catch (error) {
        handleAxiosError(error)
      } finally {

        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    }
  };

  const handleImportarExcelNodo = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const file = event.target.files[0];
      setUploadFile(file);

      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const data = e.target?.result;
          if (data) {

            const wb = XLSX.read(data, { type: 'binary' });
            const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet

            const aux: any[] = XLSX.utils.sheet_to_json<Nodo>(ws, { header: ['nombre_rb', 'ciudad', 'coordenadas', 'sector', 'detalles'] });
            const auxClean: GetNodoParams[] = [];
            aux.shift();
            aux.map((value) => {
              if (value.detalles === "GPON") {
                auxClean.push({
                  codigo: value.codigo ?? value.nombre_rb,
                  nombre: value.nombre_rb,
                  ciudad: value.ciudad,
                  direccion: '',
                  coordenadas: value.coordenadas ?? '0',
                  sector: value.sector,
                  es_radiobase: false,
                });
              }
            });

            if (aux.length == 0) setAlert(true, 'No se han encontrado datos en el excel.', AlertSeverityEnum.warning);

            if (aux.length > 0) {
              setConfirmDialogIsOpen(true);
              setConfirmDialog({
                cancelTextBtn: 'Cancelar',
                isOpen: true,
                title: '¡Confirmación!',
                subtitle: `El archivo Excel "${file.name}" se ha cargado correctamente. ¿Te gustaría importar a la base de datos?`,
                onClose() {
                  setUploadFile(null);
                  setConfirmDialogIsOpen(false);
                },
                async onConfirm() {
                  if (!file) return setAlert(true, 'Archivo no cargado', AlertSeverityEnum.warning);
                  await fetchImportarExcelNodo.mutateAsync({
                    nodos: auxClean
                  });

                  setConfirmDialogIsOpen(false);
                },
              });
            }

            setCleanUploadFile(auxClean);
          }
        };
        reader.readAsArrayBuffer(file);
      } catch (error) {
        handleAxiosError(error)
      } finally {

        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    }
  };

  //CARGCAR EXCEL
  const handleImportarExcelRadioBase = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const file = event.target.files[0];
      setUploadFile(file);
      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const data = e.target?.result;
          if (data) {
            const wb = XLSX.read(data, { type: 'binary' });
            const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet

            const aux: IRadioBaseExcel[] =
              XLSX.utils.sheet_to_json<IRadioBaseExcel>(ws, { header: ['codigo', 'nombre', 'direccion', 'coordenadas', 'estado'] }); // generate objectss
            const auxClean: RadioBase[] = [];
            aux.shift();
            aux.map((value) => {
              auxClean.push({
                nombre: value.nombre.toUpperCase(),
                codigo: value.codigo.toUpperCase(),
                coordenadas: value.coordenadas ? value.coordenadas : '0',
                direccion: value.direccion.toUpperCase(),
                estado: value.estado == 'Activo',
              })
            });



            if (aux.length == 0) setAlert(true, 'No se han encontrado datos en el excel.', AlertSeverityEnum.warning);

            if (aux.length > 0) {
              setConfirmDialogIsOpen(true);
              setConfirmDialog({
                cancelTextBtn: 'Cancelar',
                isOpen: true,
                title: '¡Confirmación!',
                subtitle: `El archivo Excel "${file.name}" se ha cargado correctamente. ¿Te gustaría importar a la base de datos?`,
                onClose() {
                  setUploadFile(null);
                  setConfirmDialogIsOpen(false);
                },
                async onConfirm() {
                  if (!file) return setAlert(true, 'Archivo no cargado', AlertSeverityEnum.warning);
                  await fetchImportarExcelRadioBase.mutateAsync({
                    radiobases: auxClean
                  });

                  setConfirmDialogIsOpen(false);
                },
              });
            }
            setCleanUploadFile(auxClean);
          }
        };
        reader.readAsArrayBuffer(file);
      } catch (error) {
        handleAxiosError(error)
      } finally {

        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    }
  };


  const handleImportarOLT = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const file = event.target.files[0];
      setUploadFile(file);
      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const data = e.target?.result;
          if (data) {
            const wb = XLSX.read(data, { type: 'binary' });
            const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet

            const aux: IOLTExcel[] = XLSX.utils.sheet_to_json<IOLTExcel>(ws, { header: ['PROVINCIAS', 'NOMBRE_OLT', 'HOSTNAME', 'PPPoE', 'IP_PPPoE', 'RED_IPv4', 'RED_IPv6'] }); // generate objectss
            const auxClean: OLTBase[] = [];
            aux.shift();

            let detectErrorsWhileProccessing = false
            try {
              aux.map((value) => {
                auxClean.push(
                  {
                    nombre: value.NOMBRE_OLT.toUpperCase(),
                    hostname: value.HOSTNAME.toUpperCase(),
                    password: null,
                    provincia: value.PROVINCIAS.toUpperCase(),
                    pppoe: value.PPPoE.toUpperCase(),
                    ip_pppoe: value.IP_PPPoE.toUpperCase(),
                    ipv4_red: value.RED_IPv4.toUpperCase(),
                    ipv6_red: value.RED_IPv6.toUpperCase()
                  })
              });
            } catch (error) {
              detectErrorsWhileProccessing = true
              setAlert(true, 'El archivo no cumple con el formato requerido. Revise que cada registro se encuentre en una celda única y evite celdas combinadas.', AlertSeverityEnum.warning);
            }



            if (aux.length == 0) setAlert(true, 'No se han encontrado datos en el excel.', AlertSeverityEnum.warning);

            if (aux.length > 0 && !detectErrorsWhileProccessing) {
              setConfirmDialogIsOpen(true);
              setConfirmDialog({
                cancelTextBtn: 'Cancelar',
                isOpen: true,
                title: '¡Confirmación!',
                subtitle: `El archivo Excel "${file.name}" se ha cargado correctamente. ¿Te gustaría importar a la base de datos?`,
                onClose() {
                  setUploadFile(null);
                  setConfirmDialogIsOpen(false);
                },
                async onConfirm() {
                  if (!file) return setAlert(true, 'Archivo no cargado', AlertSeverityEnum.warning);
                  await fetchImportarExcelOLTs.mutateAsync({
                    olts: auxClean
                  });

                  setConfirmDialogIsOpen(false);
                },
              });
            }
            setCleanUploadFile(auxClean);
          }
        };
        reader.readAsArrayBuffer(file);
      } catch (error) {
        handleAxiosError(error)
      } finally {

        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    }
  };


  const handleImportarTroncales = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const file = event.target.files[0];
      setUploadFile(file);
      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const data = e.target?.result;
          const auxDataTroncales: OLTsTroncalBase[] = []
          if (data) {
            try {
              const wb = XLSX.read(data, { type: 'binary' });
              //obtener cantidad de hojas en el excel
              const sheetCount = wb.SheetNames.length;

              if (sheetCount === 0) {
                setAlert(true, 'No se puede procesar el archivo. Puede que se encuentre vacío o el formato no sea el correcto', AlertSeverityEnum.warning);
                console.log("Excel vacío")
              }

              //recorre las hojas
              for (let sheet = 0; sheet < sheetCount; sheet++) {

                const ws = wb.Sheets[wb.SheetNames[sheet]];

                //obtenemos cantidad de grupo de troncales a subir 
                //(columnas en donde se encuentra el nombre de la troncal)
                const rowIndex = 2;
                let columnCount = 0;
                for (let col = 0; ; col++) {
                  const cell = ws[XLSX.utils.encode_cell({ r: rowIndex, c: col })];
                  if (!cell) break; // Rompe si no hay más celdas en la fila
                  columnCount++;
                }

                //recorro cada columna de la hoja
                for (let rowInColumn = 0; rowInColumn < columnCount; rowInColumn++) {
                  const auxObjectOLTTroncal: OLTsTroncalBase = {
                    nombre: "",
                    hostname: "",
                    naps: []
                  }
                  const aux = XLSX.utils.sheet_to_json(ws, { header: 1 }) as (string | null)[][];
                  // Omito las primeras dos filas e itero por fila para tomar los valores
                  // de cada fila de la columna
                  const columnData = aux.slice(2).map(row => row[rowInColumn]);

                  //lleno el objeto dado el formato requerido
                  auxObjectOLTTroncal.nombre = columnData[0] ?? ""
                  auxObjectOLTTroncal.hostname = columnData[1] ?? ""
                  const auxNaps: string[] = [];
                  for (
                    let index = 4;
                    index < columnData.length;
                    index++) {
                    if (columnData[index] !== undefined && columnData[index] !== "") {
                      auxNaps.push(columnData[index] ?? "")
                    }
                  }

                  auxObjectOLTTroncal.naps = auxNaps ?? [];
                  auxDataTroncales.push(auxObjectOLTTroncal)

                }

              }
              setConfirmDialogIsOpen(true);
              setConfirmDialog({
                cancelTextBtn: 'Cancelar',
                isOpen: true,
                title: '¡Confirmación!',
                subtitle: `El archivo Excel "${file.name}" se ha cargado correctamente. ¿Te gustaría importar a la base de datos?`,
                onClose() {
                  setUploadFile(null);
                  setConfirmDialogIsOpen(false);
                },
                async onConfirm() {
                  if (!file) return setAlert(true, 'Archivo no cargado', AlertSeverityEnum.warning);
                  await fetchImportarExcelOLTsTroncales.mutateAsync({
                    oltsTroncales: auxDataTroncales
                  });

                  setConfirmDialogIsOpen(false);
                },
              });
            }
            // setCleanUploadFile(auxClean);

            catch (error) {
              setAlert(true, 'El archivo no cumple con el formato requerido. Revise que cada registro se encuentre en una celda única y evite celdas combinadas.', AlertSeverityEnum.warning);
            }
          }
        };
        reader.readAsArrayBuffer(file);
      } catch (error) {
        handleAxiosError(error)
      } finally {

        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    }
  };

  const handleImportarInventariable = async (event: React.ChangeEvent<HTMLInputElement>) => {

    try {
      if (!event.target.files) return;

      const file = event.target.files[0];

      setConfirmDialogIsOpen(true);
      setConfirmDialog({
        cancelTextBtn: 'Cancelar',
        isOpen: true,
        title: '¡Confirmación!',
        subtitle: `El archivo Excel "${file.name}" se ha cargado correctamente. ¿Te gustaría importar a la base de datos?`,
        onClose() {
          setUploadFile(null);
          setConfirmDialogIsOpen(false);
        },
        async onConfirm() {
          setConfirmDialogIsOpen(false);
          const resp = await handleUploadFile(file, BucketAwtENUM.DOCUMENTO_INVENTARIABLE)
          await fetchImportarExcelInventario({
            url: resp.url
          })
        },
      });



    } catch (error) {
      //handleAxiosError(error)
    } finally {

      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }

  };
  ///**proveedor */
  const handleImportProveedor = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      if (!event.target.files) return;

      const file = event.target.files[0];

      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target?.result;
        if (!data) return;

        // Leer el archivo Excel
        const wb = XLSX.read(data, { type: 'array' }); // array para readAsArrayBuffer
        const ws = wb.Sheets[wb.SheetNames[0]]; // primera hoja

        // Convertir hoja a JSON, con los headers correctos
        const rows: any[] = XLSX.utils.sheet_to_json(ws, { header: 1 }); // header: 1 devuelve arrays de filas

        // Ignorar la primera fila (títulos)
        const dataRows = rows.slice(1);

        // Validar que haya al menos un elemento no vacío
        const hasData = dataRows.some((row: ProveedorExcel[]) => row.some(cell => cell !== null && cell !== undefined && cell.toString().trim() !== ''));

        if (!hasData) {
          toast.warning("No hay datos reales en las filas después de los títulos.");
          return;
        }
        // Si pasa la validación, se abre el confirm dialog
        setConfirmDialogIsOpen(true);
        setConfirmDialog({
          cancelTextBtn: 'Cancelar',
          isOpen: true,
          title: '¡Confirmación!',
          subtitle: `El archivo Excel "${file.name}" se ha cargado correctamente. ¿Te gustaría importar a la base de datos?`,
          onClose() {
            setUploadFile(null);
            setConfirmDialogIsOpen(false);
          },
          async onConfirm() {
            setConfirmDialogIsOpen(false);
            const resp = await handleUploadFile(file, BucketAwtENUM.DOCUMENTO_PROVEEDOR);
            await fetchImportarExcelProveedor({ url: resp.url });
          },
        });
      };
      reader.readAsArrayBuffer(file); // leer como array buffer para Excel real
    } catch (error) {
      //handleAxiosError(error)
    } finally {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };
  //solicitudEgreso/pedido
  const handleImportPedido = async (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('event', event)
    const file = event.target.files?.[0]
    try {
      if (!file) return

      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target?.result;
        if (!data) return;
        //leer el archvivo Excel
        const wb = XLSX.read(data, { type: 'array' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });
        //saltar la fila de encambezados 
        const dataRows = rows.slice(1).filter(row => row[0])
        if (dataRows.length === 0) {
          return toast.warning('El archivo no contiene productos.')
        }
        console.log('productos del excel', dataRows)
        setConfirmDialogIsOpen(true)
        setConfirmDialog({
          cancelTextBtn: 'Cancelar',
          isOpen: true,
          title: '¡Confirmación!',
          subtitle: `El archivo Excel "${file.name}" tiene ${dataRows.length} productos. ¿Deseas importar?`,
          onClose() {
            setUploadFile(null)
            setConfirmDialogIsOpen(false);
          },
          async onConfirm() {
            setConfirmDialogIsOpen(false)
            const resp = await handleUploadFile(file, BucketAwtENUM.DOCUMENTO_SOLICITUD_PEDIDO)
            console.log('url_enviar', resp)
            //TODO CUANDOE LE BACKEND ESTE LISYTO 
            //await({url: resp.url})

          }
        })
      }
      reader.readAsArrayBuffer(file)

    }catch(error){
     toast.error('Error al procesar el archivo Excel.')
    }finally{
      if(fileInputRef.current) fileInputRef.current.value=''
    }
  


  }
  const descargarExcelUrl = async (
    url?: string | null,
    fileName: string = 'archivo.xlsx') => {
    try {

      if (!url) {
        toast.info('No existe documento. [404]')
        return;
      }

      const response = await axios.get(url, {
        responseType: "blob", // Importante para obtener el archivo como un blob
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);
    } catch (error) {
      toast.warning('Error al descargar el archivo Excel');
    }
  };



  const descargarTxtDesdeUrl = async (
    url?: string | null,
    nombreArchivo: string = "archivo.txt") => {

    try {
      if (!url) {
        toast.info('No existe documento. [404]')
        return;
      }

      const response = await fetch(url);
      if (!response.ok) throw new Error("Error al descargar el archivo");

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = nombreArchivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      toast.warning('Error al descargar el archivo TXT');

    }
  };


  async function descargarPdfDesdeurl(
    url?: string | null,
    fileName: string = 'documento.pdf'
  ): Promise<void> {

    if (!url) {
      toast.info('No existe documento. [404]')
      return;
    }

    try {

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Error en la descarga: ${response.statusText}`);
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      toast.warning('Error al descargar el archivo PDF');
    }
  }

  /**
 * Descarga un archivo Excel (binario) desde un endpoint usando Axios.
 * @param endpointUrl La URL del endpoint que devuelve el binario de Excel.
 * @param filename El nombre deseado para el archivo descargado (e.g., "reporte.xlsx").
 */
  async function downloadExcelFileWithAxios(
    endpointUrl: string,
    filename: string = 'data.xlsx'
  ): Promise<{
    code: number
  }> {

    const token = useAuthStore.getState().token;

    const config: AxiosRequestConfig = {
      timeout: 300000,// 5 minutos en milisegundos
      method: 'GET',
      url: endpointUrl,
      responseType: 'blob',
      headers: {
        'Authorization': `Token ${token}`,
      },
    };

    try {

      const response = await axios(config);
            
      if (response.status == 209) {
        return {
          code: 209
        }
      }

      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const contentDisposition = response.headers['content-disposition'];
      let finalFilename = filename;

      if (contentDisposition) {
        const matches = /filename="?([^"]+)"?/i.exec(contentDisposition);
        if (matches && matches[1]) {
          finalFilename = matches[1];
        }
      }
      a.download = finalFilename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      return {
        code: response.status
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error('Fallo en la descarga. Detalles:', error.response?.data || error.message);
      } else {
        console.error('Error inesperado:', error);
      }

      return {
        code: 504
      }

    }
  }


  return {
    downloadExcelFileWithAxios,

    descargarExcelUrl,
    descargarTxtDesdeUrl,
    descargarPdfDesdeurl,

    handleUploadFile,
    handleUpdateFile,
    handleDeleteFile,
    handleImportarExcelSectorCobertura,
    handleImportarExcelNodo,
    handleImportarExcelRadioBase,
    handleImportarOLT,
    handleImportarTroncales,
    handleImportarInventariable,
    handleImportProveedor,
    fileInputRef,
    uploadFile,
    cleanUploadFile,
    setUploadFile,
    isPendingInventableExcel,
    isPendingProveedorExcel,
    handleImportPedido,
  };
};
